import { Component, Vue } from 'vue-property-decorator';
import FeedbackList from '@/components/FeedbackList/FeedbackList.vue';

@Component<Feedback>({
  components: {
    FeedbackList,
  },
})
export default class Feedback extends Vue {
  protected $pageTitle = 'Feedback';
}
